import React, { useState, useEffect, useContext } from 'react';

import {
    makeStyles,
    Box,
    CircularProgress,
    Tabs,
    Tab,
} from '@material-ui/core'
import {
    api,
    menuHelper,
    PortalContext,
    IconEnlaceExt,
    esGestiona
} from '@portal/arq-portal-core';

import { TabMenuPaginado } from './TabMenu';
import { TabPersonasPaginado } from './TabPersonas';

const useStyles = makeStyles({
    publicacionesTab: {
        '& .MuiTab-wrapper': {
            display: 'flex',
            flexDirection: 'row-reverse',
            padding: '0 80px'
        }
    },
    publicacionesIcon: {
        width: '18px',
        marginBottom: '0px !important',
        marginLeft: '10px',
    },
    tabSection: {
        borderTop: '1px solid #d6d8d8',
        '& .MuiTabs-indicator': {
            top: '0px',
            height: '4px',
        },
        '& .MuiTab-textColorInherit.Mui-selected': {
            fontWeight:'bold',
            color: '#606060',
            borderBottom: '1px solid transparent',
            borderLeft: '1px solid transparent',
            borderRight: '1px solid transparent',
            PointerEvent: 'none',
        },
        '& .MuiTab-root': {
            borderBottom: '1px solid #d6d8d8',
            borderLeft: '1px solid #d6d8d8',
            borderRight: '1px solid #d6d8d8',
            color: '#606060',
            opacity: '1',
            '& .MuiTouchRipple-root': {
                display: 'none',
            }
        },
        '& .MuiTab-labelIcon': {
            minHeight: '48px',
        },

    },
    menuPersonasTab : {
        '& .MuiTab-wrapper': {
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            '& .MuiCircularProgress-root': {
                order: 1
            }
        }
    },
    tabIcono: {
        display: 'block'
    },
    oculto: {
        display: 'none' 
    },
});

const generarRuta = (menuOptionPath: any) => {
    return menuOptionPath.reduce((accum: string, el: any) => {
        return `${accum} > ${el.titulo}`;
    }, 'Inicio');
};

export interface TabSeccionProps {
    texto: string;
};

const ENLACE_PUBLICACIONES = 'https://grupocatalanaoccidente.sharepoint.com/sites/portalpublicaciones/SitePages/Resultados.aspx';

export const TabsSeccion = ({ texto }: TabSeccionProps) => {

    const [valor, setValor] = useState(0);
    const [ resultsPersonas, setResultsPersonas ] = useState<any[]>([]);
    const [ errorPersonas, setErrorPersonas ] = useState<any>();
    const [ isLoadingPersonas, setIsLoadingPersonas ] = useState(false);
    const [ resultsMenu, setResultsMenu ] = useState<any[]>([]);
    const { menu, cia, ciaGestiona } = useContext(PortalContext);
    const { getMenuOptionPath, findMenuOptions } = menuHelper;
    const clases = useStyles();

    const obtenerPersonas = async () => {
        try {
            const personas = await api.post('/be/personas', {
                "Entrada": {
                    "Busqueda": texto
                }
            });
            setResultsPersonas(personas?.Salida?.Resultados ?? []);
        } catch(error) {
            setErrorPersonas(error);
        } finally {
            setIsLoadingPersonas(false);
        }
    };

    const formatearMenus = (menus: any[] | null | undefined) => {
        if (!menus) {
            return [];
        } else {
            return menus.map((item) => {
                return {
                    url: item.url,
                    titulo: item.titulo,
                    path: generarRuta(getMenuOptionPath(menu, item.url))
                };
            });
        }
    };

    // @ts-ignore
    const manejarCambio = (event: React.SyntheticEvent, nuevoValor: number) => {
        if (nuevoValor !== 2) {
            setValor(nuevoValor);
        }
    };

    useEffect(() => {
        setResultsMenu(formatearMenus(findMenuOptions(menu, texto)));
        setIsLoadingPersonas(true);
        setErrorPersonas(undefined);
        obtenerPersonas();
    }, [texto]);

    return (
        <Box sx={{ width: '100%' }} style={{ background: 'white', marginTop: '20px' }} className={clases.tabSection}>
            <Tabs
                value={valor}
                onChange={manejarCambio}
                indicatorColor="primary"
                textColor="inherit"
                variant="fullWidth"
                aria-label="pestañas de búsqueda"
            >
                <Tab className={clases.menuPersonasTab}
                    label={`Puntos de menú (${resultsMenu.length})`}
                />
                <Tab className={clases.menuPersonasTab}
                    label={`Personas ${!isLoadingPersonas && !errorPersonas ? `(${resultsPersonas.length})` : ''}`}
                    icon={<CircularProgress color="primary" size={16} thickness={2} className={`${isLoadingPersonas ? clases.tabIcono : clases.oculto}`} />}
                />
                <Tab className={clases.publicacionesTab}
                    component="a"
                    href={`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_PUBLICACIONES : ENLACE_PUBLICACIONES}?cia=${esGestiona()? ciaGestiona : cia  }#${texto}`}
                    target="_blank"
                    label="Publicaciones"
                    icon={<IconEnlaceExt className={clases.publicacionesIcon} />}
                />
            </Tabs>
            {valor === 0 &&
                <TabMenuPaginado texto={texto} resultados={resultsMenu} />
            }
            {valor === 1 && !isLoadingPersonas &&
                <TabPersonasPaginado texto={texto} resultados={resultsPersonas ?? []} error={errorPersonas} />
            }
        </Box>
    );
};